module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("The way to find out whether or not anything exists is to depend on the testimony of the ears and eyes of the multitude. If some have heard it or some have seen it, then we have to say it exists. If no one has heard it and no one has seen it, then we have to say it does not exist. So, then, why not go to some village or some district and inquire? If from antiquity to the present, and since the beginning of Man, there are men who have seen the bodies of ghosts and spirits and heard their voices, how can we say that they do not exist?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('b', [_vm._v("Mo Tzu, Chinese philosopher 470–391 BCE")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5470a788","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04thewaytofind.vue
// module id = 69
// module chunks = 0